export function validIndexForIncrementality(currentRetailerId: string, _stage: string) {
  return ['1', '11', '14', '15', '16', '17', '18', '28', '29', '30', '4', '53'].includes(currentRetailerId);
}
